import { FC } from 'react';
import Button from '@/components/Button/Button';
import { Document } from '@contentful/rich-text-types';
import MainBodyToReact from '@/features/contentful/components/MainBodyToReact';
import { useContentfulInspectorMode } from '@contentful/live-preview/react';
import CustomImage from '../CustomImage/CustomImage';

interface Props {
    title: string;
    summary?: Document;
    image?: string;
    path?: string;
    linkText?: string;
    id: string;
    target?: string;
    imageAlt?: string;
}

const CarouselCard: FC<Props> = ({
    title,
    imageAlt,
    summary,
    id,
    image,
    path,
    linkText = 'Learn more',
    target,
}) => {
    const inspectorProps = useContentfulInspectorMode({ entryId: id });

    return (
        <div className="tw-flex tw-flex-col md:tw-flex-row tw-max-w-full sm:tw-w-[96%] tw-mx-auto tw-min-h-[500px] sm:tw-min-h-[300px] md:tw-min-h-[350px] md:tw-h-[350px]  tw-rounded-lg tw-bg-white tw-overflow-hidden">
            {image ? (
                <div className="tw-relative tw-w-full tw-h-[200px] md:tw-w-1/2 md:tw-h-[350px] tw-overflow-hidden tw-border-br-135 sm:tw-border-br-150 md:tw-shadow-xl">
                    <CustomImage
                        src={image}
                        alt={imageAlt ?? title}
                        layout="fill"
                        className="tw-w-full tw-h-full tw-object-cover tw-object-center"
                        {...inspectorProps({
                            fieldId: 'image',
                        })}
                    />
                </div>
            ) : null}
            <div
                className="md:tw-hidden tw-font-gotham-bold tw-text-[#003865] tw-text-[22px] tw-mt-[20px] tw-px-[20px] "
                {...inspectorProps({
                    fieldId: 'title',
                })}
            >
                {title}
            </div>
            <div className="md:tw-w-1/2 tw-p-[20px] md:tw-p-[45px]">
                <h3
                    className="tw-hidden md:tw-block tw-text-[#333f48] tw-text-[24px] tw-pb-[15px] tw-font-gotham-bold"
                    {...inspectorProps({
                        fieldId: 'title',
                    })}
                >
                    {title}
                </h3>
                <div
                    {...inspectorProps({
                        fieldId: 'content',
                    })}
                >
                    <MainBodyToReact
                        body={summary}
                        classes={{
                            p: 'tw-font-gotham-book tw-text-[#4b4f54] tw-text-[16px] md:tw-text-[14px] tw-leading-[21px] tw-pb-[10px]',
                        }}
                    />
                </div>
                <div
                    {...inspectorProps({
                        fieldId: 'link',
                    })}
                    className="tw-pt-[20px] tw-w-[200px]"
                >
                    {path && (
                        <Button label={linkText} path={path} id={`${id}${path}`} target={target} />
                    )}
                </div>
            </div>
        </div>
    );
};

export default CarouselCard;
